import type {Nullable} from "../../bootstrap/common/types";

export class EopSliderElement extends HTMLElement {

    public image: Nullable<HTMLElement>;

    public constructor(element: Element) {
        super();

        this.image = element.querySelector(".eop-image");
    }
}

customElements.define("eop-slider-element", EopSliderElement);

